import "materialize-css";

const MaterialSelectDirective = function () {
    return {
        link: function (scope, element, attrs) {
            var regs = [];

            function updateSelector() {
                // Each time the observed angular scope model changes, an angular digest
                // will re-populate the page with appropriate select element contents. In
                // response to any new option elements, the MaterializeCss elements
                // then needs to be rebuilt.
                // From http://materializecss.com/forms.html:
                // "
                //  ...you will need a separate call for any dynamically generated select
                //  elements your page generates.
                // "
                element.formSelect();

                var dirty = element.hasClass("ng-dirty") && !element.hasClass("ng-pristine") && !element.hasClass("ng-untouched");
                var valid = dirty && element.hasClass("ng-valid");
                var invalid = dirty && element.hasClass("ng-invalid");

                var input = element.siblings("div.select-wrapper input.select-dropdown");

                if (input.length > 0) {
                    if (valid) {
                        input.addClass("valid");
                        input.removeClass("invalid");
                    } else if (invalid) {
                        input.removeClass("valid");
                        input.addClass("invalid");
                    } else {
                        input.removeClass("valid");
                        input.removeClass("invalid");
                    }
                }
            }

            regs.push(scope.$watch(function () {
                return attrs.disabled;
            }, updateSelector));

            // Trigger the rebuilding of MaterializeCss's ancillary elements on content
            // (options) change.  Changes to the select element's options are prompted
            // by angular digests repopulating the dom during a digest. Failure to rebuild
            // in correspondance with the select element will lead to stale
            // MaterializeCss select item lists.
            element.each(function () {
                var elementMutationObserver = new MutationObserver(function () {
                    scope.$apply(updateSelector);
                });
                elementMutationObserver.observe(
                    this,
                    {
                        // Monitor changes, additions and removals of all descendant nodes.
                        childList: true,
                        subtree: true,
                        // Observe the "selected" attribute for change, to ensure that the
                        // MaterializeCss's corresponding elements are rebuilt when the
                        // "selected" attribute is added/removed on a child <option> element.
                        attributes: true,
                        attributeFilter: ["selected"]
                    });
                regs.push(function () { elementMutationObserver.disconnect(); });
            });

            // Run the initialisation for the first time
            updateSelector();

            scope.$on("$destroy",
                function () {
                    regs.forEach(function (deregister) { deregister(); })
                });
        }
    }
};

export { MaterialSelectDirective };